import React from "react";
import {parseHydraDocumentation} from "@api-platform/api-doc-parser";
import baseFetchHydra from "./fetchHydra";
import { Route, Navigate } from 'react-router-dom';
import keycloak from "../../keycloak";

export const fetchHeaders = (method = '') => ({
  Authorization: `Bearer ${keycloak.token}`,
  ...((method === 'PATCH') && {
    'Content-Type': 'application/merge-patch+json'
  })
});

export const fetchHydra = (url, options = {}) => {
  const method = options.method

  return keycloak.token
    ? baseFetchHydra(url, {
      ...options,
      headers: new Headers(fetchHeaders(method)),
    })
    : baseFetchHydra(url, options)
}

export const apiDocumentationParser = (entrypoint) =>
  parseHydraDocumentation(
    entrypoint,
    keycloak.token
      ? { headers: new Headers(fetchHeaders()) }
      : {}
  ).then(
    ({ api }) => ({ api }),
    (result) => {
      if (result.status === 401) {
        localStorage.removeItem("token");

        return Promise.resolve({
          api: result.api,
          customRoutes: [
            <Route path="/" render={() => {
              return !keycloak.token ? window.location.reload() : <Navigate to="/" />
            }} />
          ],
        });
      }

      return Promise.reject(result);
    },
  );
